import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ScriptService } from '../../script.service';
import { DefaultComponent } from '../../layouts/default/default.component';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../service/general.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
declare var $: any;
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit, AfterViewInit {

  constructor(
    private DefaultComponent: DefaultComponent,
    private scriptService: ScriptService,
    private GeneralService: GeneralService,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.get_data();
  }

  ngOnInit(): void {
  }
  ngAfterViewInit() {
    this.scriptService.load('app', 'dashboard');
  }
  get_data() {
    // this.toastr.success("Hello, I'm the toastr message.")
    var th = this;
    var datas = [];
    this.GeneralService.getCategoryList().subscribe((data: any) => {
      if (data.status) {
        setTimeout(function () {


          $.each(data.category_data, function (index, value) {
            var status = (value.tc_status) ? '<a href="javascript:;" data-id="' + value.tc_id + '" data-status="0" class="badge bg-success change_status">Active</a>' : '<a href="javascript:;" data-id="' + value.tc_id + '" data-status="1" class="badge bg-danger change_status">Deactive</a>';
            datas.push([
              value.tc_id,
              value.tc_name,
              status,
              '<button  data-url="/category-edit/' + value.tc_id + '" class="edit_btn btn btn-primary btn-icon mr-2"><i class="fa fa-edit"></i></button>&nbsp;' +
              '<button type="button" data-id=' + value.tc_id + ' class="delete_btn btn btn-danger btn-icon"><i class="fa fa-trash"></i></button>'
            ]);
          });

          $('#DataTable').DataTable({
            destroy: true,
            data: datas,
            cache: false,
            order: [[0, 'DESC']],
            columnDefs: [{ "targets": 0, "visible": false }],
            stateSave: true,
            fnDrawCallback: function () {
              $('.edit_btn').click(function () {
                var url = $(this).data('url');
                th.router.navigate([url]);
              })
              $('.delete_btn').click(function () {
                var id = $(this).data('id');
                th.remove(id);
              })
              $('.change_status').click(function () {
                var id = $(this).data('id');
                var status = $(this).data('status');
                th.DefaultComponent.loaderShow()
                $.ajax({
                  url: environment.baseUrl + 'changeCategoryStatus',
                  method: 'post',
                  data: { id: id, status: status },
                  dataType: 'json',
                  success: function (res) {
                    th.DefaultComponent.loaderHide()
                    if (res.status) {
                      th.toastr.success(res.message)

                      th.get_data();
                    } else {
                      th.toastr.error(res.message)
                    }

                  }
                });
              });
            }
          });
        }, 500);
      }
    });
  }
  remove(id) {
    var th = this;
    Swal.fire({
      title: 'Are you sure?',
      text: 'to Delete this record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        th.DefaultComponent.loaderShow()
        $.ajax({
          url: environment.baseUrl + 'deleteCategory',
          method: 'POST',
          data: { id: id },
          dataType: 'json',
          success: function (res) {
            th.DefaultComponent.loaderHide()
            if (res.status) {
              th.toastr.success(res.message)
              th.get_data();
            } else {
              th.toastr.error(res.message)
            }
          }
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log('cancel')
      }
    })

  }
}
